import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import BlogCategories from '../components/BlogCategories';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';
import getLanguageDropdown from '../utils/getLanguageDropdown';
import ForumNav from '../components/ForumNav';
import BlogOverviewItem from '../components/BlogOverviewItem';
import FeaturedBlogItem from '../components/FeaturedBlogItem';
import BlogListState from '../states/BlogListState';
export default class BlogOverview extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "list", void 0);
    _defineProperty(this, "languages", void 0);
    _defineProperty(this, "currentSelectedLanguage", void 0);
    _defineProperty(this, "featuredCount", void 0);
    _defineProperty(this, "showCategories", void 0);
    _defineProperty(this, "showForumNav", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(extractText(app.translator.trans('fof-blog.forum.blog')));
    this.bodyClass = 'BlogOverviewPage';
    this.languages = app.store.all('discussion-languages');
    this.currentSelectedLanguage = m.route.param('lang') ? m.route.param('lang') : app.data.locale;

    // Send history push
    app.history.push('blog', extractText(app.translator.trans('fof-blog.forum.blog')));
    this.featuredCount = parseInt(app.forum.attribute('blogFeaturedCount'));
    this.showCategories = true;
    this.showForumNav = true;

    // The state consumes the preloaded API document, when one is available.
    this.list = new BlogListState(this.listParams());
    this.list.refresh();
  }
  listParams() {
    return {
      category: m.route.param('slug') || undefined,
      language: this.languages.length > 0 ? this.currentSelectedLanguage : undefined
    };
  }

  /**
   * All loaded articles; the first `featuredCount` are displayed as featured.
   */
  articles() {
    return this.list.getPages().flatMap(page => page.items);
  }
  title() {
    if (!m.route.param('slug')) {
      return m("h2", null, app.translator.trans('fof-blog.forum.recent_posts'));
    }
    const tag = app.store.all('tags').filter(tag => tag.slug() === m.route.param('slug'));
    return m("h2", null, tag && tag[0] && tag[0].name(), m("small", null, ' ', "- ", m(Link, {
      href: app.route('blog')
    }, app.translator.trans('fof-blog.forum.return_to_overview'))));
  }

  /**
   * The blog reuses the forum's welcome hero, when enabled.
   */
  hero() {
    if (!app.forum.attribute('blogAddHero')) return null;
    return m(WelcomeHero, null);
  }
  view() {
    const defaultImage = app.forum.attribute('blogDefaultImageUrl') ? "url(".concat(app.forum.attribute('blogDefaultImageUrl'), ")") : null;
    const LanguageDropdown = getLanguageDropdown();
    const loading = this.list.isInitialLoading();
    const articles = this.articles();
    const featuredPosts = articles.slice(0, this.featuredCount);
    const posts = articles.slice(this.featuredCount);
    return [this.hero(), m("div", {
      className: 'FoFBlogOverview'
    }, m("div", {
      className: 'container'
    }, m("div", {
      className: 'BlogFeatured'
    }, m("div", {
      className: 'BlogOverviewButtons'
    }, app.forum.attribute('canWriteBlogPosts') && m(Button, {
      className: 'Button',
      onclick: () => this.newArticle(),
      icon: 'fas fa-pencil-alt'
    }, app.translator.trans('fof-blog.forum.compose.write_article')), this.languages !== null && this.languages.length >= 1 && LanguageDropdown && m(LanguageDropdown, {
      selected: this.currentSelectedLanguage,
      onclick: language => {
        if (typeof language !== 'string') return;
        this.currentSelectedLanguage = language;
        m.route.set(document.location.pathname, {
          lang: language
        });
        this.list.refreshParams(this.listParams(), 1);
      }
    })), this.title(), m("div", {
      style: {
        clear: 'both'
      }
    }), m("div", {
      class: "BlogFeatured-list"
    }, loading && [...new Array(this.featuredCount).fill(undefined)].map(() => m("div", {
      class: "BlogFeatured-list-item BlogFeatured-list-item-ghost"
    }, m("div", {
      class: "BlogFeatured-list-item-details"
    }, m("h4", null, "\xA0"), m("div", {
      class: "data"
    }, m("span", null, m("i", {
      class: "far fa-wave"
    })))))), !loading && featuredPosts.map(article => m(FeaturedBlogItem, {
      article: article,
      defaultImage: defaultImage
    })))), m("div", {
      className: 'BlogScrubber'
    }, m("div", {
      className: 'BlogList'
    }, loading && [false, false, true, false].map(sized => {
      return m("div", {
        className: "BlogList-item BlogList-item-".concat(sized ? 'sized' : 'default', " BlogList-item-ghost")
      }, m("div", {
        className: 'BlogList-item-photo FoFBlog-default-image'
      }), m("div", {
        className: 'BlogList-item-content'
      }, m("h4", null, "\xA0"), m("p", null, "\xA0"), m("div", {
        className: 'data'
      }, m("span", null, m("i", {
        className: 'far fa-wave'
      })))));
    }), !loading && posts.map(article => m(BlogOverviewItem, {
      article: article,
      defaultImage: defaultImage
    })), !loading && articles.length > 0 && !this.list.hasNext() && m("p", {
      className: 'FoFBlog-reached-end'
    }, app.translator.trans('fof-blog.forum.no_more_posts')), !loading && articles.length === 0 && m("p", {
      className: 'FoFBlog-reached-end'
    }, app.translator.trans('fof-blog.forum.category_empty')), !loading && this.list.hasNext() && m("div", {
      className: 'FoFBlog-reached-load-more'
    }, m(Button, {
      className: 'Button',
      onclick: () => this.list.loadNext(),
      icon: 'fas fa-chevron-down',
      loading: this.list.isLoadingNext()
    }, app.translator.trans('core.forum.discussion_list.load_more_button')))), m("div", {
      className: 'Sidebar'
    }, this.showCategories && m(BlogCategories, null), this.showForumNav && m(ForumNav, null)))))];
  }
  newArticle() {
    let tags = [];

    // Get current category
    const currentCategory = app.store.getBy('tags', 'slug', m.route.param('slug'));
    if (currentCategory) {
      tags.push(currentCategory);
    }

    // Redirect to the composer
    m.route.set(app.route('blogComposer', {
      tags: tags.map(tag => tag.id()).join(),
      lang: this.languages.length > 0 ? this.currentSelectedLanguage : undefined
    }));
  }
}
flarum.reg.add('fof-blog', 'forum/pages/BlogOverview', BlogOverview);